export const LABEL_COLOUR_MAP = {
  "Real Time": "#194d33",
  "Real Device": "#009ce0",
  "Web Automation": "#000000",
  "App Automation": "#4d4d4d",
  KaneAI: "#E666FF",
  "Kane CLI": "#6E56CF",
  MCP: "#876b6bd6",
  SmartUI: "#f44e3b",
  HyperExecute: "#E6B333",
  Insights: "#33FFCC",
  "Test Manager": "#B33300",
  Accessibility: "#CC80CC",
  Integrations: "#73d8ff",
  "TestMu AI Tunnel": "#68bc00",
  "LT Browser": "#fa28ff",
  Certifications: "#CCCC00",
  "Test At Scale": "#4D80CC",
  "Live App": "#808900",
  Releases: "#ff4772",
  Fixes: "#33FFCC",
  Enhancements: "#37d67a",
  Features: "#3778ff",
  Announcements: "#3778ff",
  "Agent Testing": "#FF6B35",
};

// Overrides for labels whose light-mode brand color goes invisible/dim on dark surfaces.
// Everything not listed here falls through to LABEL_COLOUR_MAP as-is.
// Distinct tones per label so users can still tell them apart at a glance.
export const LABEL_COLOUR_MAP_DARK = {
  "Real Time": "#3fb950",       // was #194d33 — brighter Primer green
  "Web Automation": "#f0f6fc",  // was #000000 — near-white (mirror of pure black)
  "App Automation": "#9198a1",  // was #4d4d4d — medium light grey
  MCP: "#c9a599",               // was #876b6bd6 — dusty rose (preserves brownish character)
};

export const getLabelColor = (label, isDark) => {
  if (isDark && LABEL_COLOUR_MAP_DARK[label]) return LABEL_COLOUR_MAP_DARK[label];
  return LABEL_COLOUR_MAP[label] || (isDark ? "#8b949e" : "#000");
};

export const ALL_POSTS_LABEL = "All Posts";
